export type Direction = Directions.UP | Directions.DOWN;

export enum Directions {
	UP = 'up',
	DOWN = 'down',
}
